import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'Levels/List',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'Levels/save',
        method: 'post',
        data
    })
}